import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { GoogleMap, LoadScript, Marker, InfoWindow } from '@react-google-maps/api';
import { useRouter } from 'next/router';

var LocalStitchMap = function LocalStitchMap(_ref) {
  var center = _ref.center,
      branches = _ref.branches,
      zoom = _ref.zoom,
      height = _ref.height;
  var GOOGLE_KEY = process.env.LOCALSTITCH_DEV_GOOGLE_API_KEY;
  var defaultSelect = {
    id: 0,
    name: '',
    location: {
      lat: 0,
      lng: 0
    }
  };

  var _useState = useState(defaultSelect),
      selected = _useState[0],
      setSelected = _useState[1];

  var router = useRouter();
  var minHeight = height === undefined ? '70vh' : height;
  var branch_markers = branches.map(function (item) {
    return {
      id: item.id,
      name: item.name,
      location: {
        lat: Number(item.latitude),
        lng: Number(item.longitude)
      }
    };
  });

  var onSelect = function onSelect(item) {
    setSelected(item);
  };

  var onClose = function onClose() {
    setSelected(defaultSelect);
  };

  var mapStyles = {
    minHeight: minHeight,
    maxHeight: '75vh'
  };

  var clickBranch = function clickBranch(id) {
    router.push("/branch/place/".concat(id));
  };

  return /*#__PURE__*/_jsx(LoadScript, {
    googleMapsApiKey: GOOGLE_KEY,
    children: /*#__PURE__*/_jsx(GoogleMap, {
      mapContainerClassName: "map-w",
      mapContainerStyle: mapStyles,
      zoom: zoom,
      center: center,
      options: {
        fullscreenControl: false,
        mapTypeControl: false,
        streetViewControl: false,
        zoomControl: false
      },
      children: branches.length > 0 && branch_markers.map(function (item) {
        return /*#__PURE__*/_jsx(Marker, {
          position: item.location,
          onClick: function onClick() {
            return onSelect(item);
          },
          children: selected.id === item.id && /*#__PURE__*/_jsx(InfoWindow, {
            position: selected.location,
            onCloseClick: function onCloseClick() {
              return onClose();
            },
            children: /*#__PURE__*/_jsxs("div", {
              className: "spot",
              children: [/*#__PURE__*/_jsxs("p", {
                children: ["\uB85C\uCEEC \uC2A4\uD2F0\uCE58 ", selected.name]
              }), /*#__PURE__*/_jsx("a", {
                onClick: function onClick() {
                  return clickBranch(selected.id);
                },
                style: {
                  cursor: 'pointer',
                  fontSize: '11px',
                  textAlign: 'center'
                },
                children: "\uC790\uC138\uD788 \uBCF4\uAE30"
              })]
            })
          })
        }, item.id);
      })
    })
  });
};

export default LocalStitchMap;